import api from "./Api";

class EstoqueMovimentacaoService {
  GetEstoqueMovimentacao(payload) {
    return api.get("/v1/estoqueMovimentacao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEstoqueMovimentacao(payload) {
    return api.post("/v1/estoqueMovimentacao/", payload).then((response) => {
      return response.data;
    });
  }

  PutEstoqueMovimentacao(payload) {
    return api.put("/v1/estoqueMovimentacao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEstoqueMovimentacao(payload) {
    return api.delete("/v1/estoqueMovimentacao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEstoqueMovimentacaoOData(payload) {
    return api.get("/OData/EstoqueMovimentacao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EstoqueMovimentacaoService();
